import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="home"
export default class extends Controller {
  connect() {
    // boostrap-select loaded from application layout
    $('#customer').selectpicker();

    self = this;
    document.getElementById('customer').onchange = function() { self.update_submit_links() };
    document.getElementById('start_date').onchange = function() { self.update_submit_links() };
    document.getElementById('end_date').onchange = function() { self.update_submit_links() };
    document.addEventListener("trix-before-initialize", event => {
      event.target.addEventListener("trix-change", event => {
        self.update_submit_links()
      })
    })
    this.update_submit_links()
  }

  update_submit_links() {
    let get_link = document.getElementById('get_link');
    let submit_link = document.getElementById('submit_link');
    let trix_editor = document.getElementById('message');

    let href = '/home/index?';

    let customer = document.getElementById('customer');
    href += customer.id + '=' + customer.value + '&';
    let start_date = document.getElementById('start_date');
    href += start_date.id + '=' + start_date.value + '&';
    let end_date = document.getElementById('end_date');
    href += end_date.id + '=' + end_date.value + '&';
    submit_link.href = href;

    href += '&commit=Get%20Link&message=' + encodeURIComponent(trix_editor.innerHTML);
    get_link.href = href;
  }
}
